export default {
  user: {
    LOGOUT: "LOGOUT"
  }
};
